module.exports = __webpack_public_path__ + "static/img/PU_Img3.7ce46828.jpg";